import queryString from "query-string";
import { GetDate } from "../../../../assets/convertUrlFilter";
import { END_DATE, FILE_TYPE, START_DATE } from "../../../../constants/filters";
import {FILE_TYPES} from "../../../../constants/file";

export const GetFilter = () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [START_DATE]: GetDate(filters[START_DATE]),
    [END_DATE]: GetDate(filters[END_DATE])
  };
};
